import { completeLoading, error } from './assistTrip.actions';
import { setLinkedRequestId } from '../../../../redux/actions/requests.actions';

export const completeMdl =
  ({ dispatch }) =>
  next =>
  (action = {}) => {
    next(action);

    if (completeLoading.match(action)) {
      if (action.payload.error) {
        dispatch(error(action.payload.error));
      } else {
        dispatch(setLinkedRequestId(action.payload.id));
        window.open(`/requester/requests/${action.payload.id}/edit`);
      }
    }
  };

export const addAssistTripMdl = [completeMdl];
